// eslint-disable-next-line import/prefer-default-export

// Cannot be hyphenated, cause an error on availabilities modal.
export const appointmentTypes = [
  'Bridal First Appointment',
  'Bridal Follow Up',
  'Bridal Measurement',
  'Bridal Fitting',
  'Bridesmaids First Appointment',
  'Bridesmaids Follow Up',
  'Bridesmaids Measurement',
  'Bridesmaids Fitting',
  'Little White Dress First Appointment',
  'Little White Dress Follow Up',
  'Little White Dress Measurement',
  'Little White Dress Fitting',
  'Evening First Appointment',
  'Evening Follow Up',
  'Evening Measurement',
  'Evening Fitting',
  'Accessories First Appointment',
  'Accessories Follow Up',
  'Accessories Measurement',
  'Accessories Fitting',
];

// Appointment types clients can select
export const clientAlterationAppointmentTypes = [
  'First Fitting',
  'Second Fitting',
  'Third Fitting',
];

// Appointment types only visible to stylist and fitters
export const alterationAppointmentTypes = [
  ...clientAlterationAppointmentTypes,
  'Try On Appointment',
];

export const bookingAppointmentTypes = [
  'Bridal First Appointment',
  'Bridal Follow Up',
  'Bridesmaids First Appointment',
  'Bridesmaids Follow Up',
  'Little White Dress First Appointment',
  'Little White Dress Follow Up',
  'Evening First Appointment',
  'Evening Follow Up',
];
